import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  SiSelectModule,
  SiSelectComponent,
  SiSelectLazyOptionsDirective
} from '@siemens/element-ng/select';

import { UserSelectSource } from './user-select-source';

@Component({
  selector: 'app-user-select',
  imports: [SiSelectModule, SiSelectComponent, FormsModule, SiSelectLazyOptionsDirective],
  templateUrl: './user-select.component.html',
  styleUrl: './user-select.component.scss'
})
export class UserSelectComponent {
  readonly optionSource = input.required<UserSelectSource>();
  readonly selectedItems = model<any[]>();
}
